var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('obk-description-connect-supported-cards-step',{attrs:{"step-number":"1"}}),_vm._v(" "),_c('obk-description-connect-unsupported-cards-step',{attrs:{"step-number":"2"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }